import React, { FC } from 'react';
import { Icon } from '@ss/mtd-react';
import { useRootStore } from '@src/model';
import dayjs from 'dayjs';
import { ISocialExam } from '@src/types/resumeDetail/socialType';
import './index.scss';

interface IProps {
  data: ISocialExam[];
  setMode: Function;
}

// 仅社招
const ExamView: FC<IProps> = (props) => {
  const { data, setMode } = props;

  const { socialResumeFormRefStore } = useRootStore();

  const storeRef = socialResumeFormRefStore;

  const handleEdit = () => {
    setMode('edit');
    storeRef.setCurrentScrollRef('exam_edit');
  };

  return (
    <div className="exam_view">
      <div className="model_title model_view">
        <div>考试</div>
        <div className="edit_icon" onClick={() => handleEdit()}>
          <Icon type="edit-o" style={{ color: '#A9AFB8', fontSize: 22 }} />
        </div>
      </div>
      {data?.map((item) => (
        <div className="model_list" key={item.renderId}>
          <div className="model_left">
            <div className="exam_name">{item.examName}</div>
            {item.examDate && <div className="exam_date">{dayjs(item.examDate).format('YYYY/MM')}</div>}
          </div>
          {item.score && (
            <div className="model_right">
              <span className="exam_score">{item.score}</span>分
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default ExamView;
